import { ToggleBox } from "../toggleBox";
import { useNavigate } from "react-router-dom";
import { ProfileDetailsProps } from "./model";
import { getSettings } from "../../services/employer-service";
import { SettingsResponse } from "../../pages/settings/model";
import { useEntitlements } from "../../context/entitlements";
import { useEffect, useState } from "react";


export const ProfileDetails = (profileProps: ProfileDetailsProps) => {
  const navigate = useNavigate();

  
  const [props, setProps] = useState<SettingsResponse>(null);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  // Planul activ vine din sursa partajată (nu din settings, care poate fi învechit).
  const { usage } = useEntitlements();

  const getProfileSettings = async () => {
    const profileSettings = (await getSettings()) as SettingsResponse;

    setProps(profileSettings);

    setNotificationsEnabled(`${profileSettings.notificationsEnabled}` === "true");
  };

  useEffect(() => {
    getProfileSettings()
  }, [])

  // Abonamentele s-au unificat în hub-ul Portofel; de aici doar navigăm acolo.
  const goToWallet = () => navigate("/credits");

  const onNotificationsToggle = (isCChecked: boolean) => {
    profileProps.onToggle(isCChecked)
    setNotificationsEnabled(isCChecked)
  };

  const redirectToSettingsUpdate = () => {
    navigate("/settings/update");
  };

  return (
    <div id="details" className="mt-[24px] gap-[16px] flex justify-between ">
      <div
        className="justify-between rounded items-center w-[100%] cursor-pointer"
        id="shimbari-detalii-t&c"
      >
        <div className="bg-figmaLightGray rounded px-[24px] py-[8px]">
          <div
            className=" flex justify-between py-[16px]"
            id="schimba-detalii-numele-locatiei"
          >
            <p className="text-figmaBlack">Nume locație</p>
            <p className="text-figmaDarkGray">
              {props && props.businessName}
            </p>
          </div>
          <div
            className=" flex justify-between border-b-2 border-t-2 py-[16px] border-figmaWhite"
            onClick={redirectToSettingsUpdate}
            id="schimba-parola-email-phone"
          >
            <p className="text-figmaBlack">Schimbă parola, emailul sau telefonul</p>
            <img src="/images/arrow-right.svg" />
          </div>
          <div
              className=" flex justify-between py-[16px]"
              id="termeni-conditii"
              onClick={() => window.open("https://jobbin.ro/confidentialitate.html", "_blank")}
          >
            <p className="text-figmaBlack">Termeni și Condiții</p>
            <img src="/images/arrow-right.svg" />
          </div>
        </div>
      </div>

      <div
        id="notificari-pret-abonament"
        className="justify-between rounded w-[100%] cursor-pointer relative"
      >
        <div className="bg-figmaLightGray rounded px-[24px] py-[8px]">
          <div
            className="flex justify-between py-[16px] relative"
            id="notificari"
          >
            <p className="text-figmaBlack">Notificări</p>
            {props != null ? (

              <ToggleBox
                isChecked={notificationsEnabled}
                onColor="#FF3366"
                onToggle={onNotificationsToggle}
              />
            ) : ""}
          </div>
          <div
            className=" flex justify-between items-center gap-3 border-t-2 py-[16px] border-figmaWhite"
            id="abonamentul-meu"
            onClick={goToWallet}
          >
            <p className="text-figmaBlack">Abonamentul meu</p>
            <div className="flex items-center gap-2">
              {usage?.hasActivePlan ? (
                <span className="text-figmaDarkGray text-right">
                  Plan {usage.label}{usage.billingInterval === "ANNUAL" ? " (anual)" : ""}
                </span>
              ) : (
                <span className="text-figmaDarkGray text-right">Fără abonament</span>
              )}
              <img src="/images/arrow-right.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
